module.exports = __webpack_public_path__ + "static/media/new4.966bb5a7.png";